import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { RIDP_ACTION_TYPES } from '@constants/actionTypes/ridpActionTypes';
import { IUserInfo, IUserViewRef } from '@modules/ridp/types/ridpTypes';
import endpoints from '@constants/configs/endpoints';
import { ResponseCodes } from '@modules/ridp/types/responseCodes';
import { configs } from '@constants/configs/configs';

const {
    routes: { RIDP_CONTACT_INFO },
} = configs;

export const setRIDPUserInfoData = data => ({
    type: RIDP_ACTION_TYPES.GET_CURRENT_USER_INFORMATION,
    payload: data,
});

export const setRIDPUserViewRef = data => ({
    type: RIDP_ACTION_TYPES.GET_CURRENT_USER_VIEWREF,
    payload: data,
});

export const setRidpPrimaryResponse = data => ({
    type: RIDP_ACTION_TYPES.VALIDATE_CURRENT_USER_INFORMATION,
    payload: data,
});

export const setRidpSecondaryResponse = data => ({
    type: RIDP_ACTION_TYPES.VALIDATE_IDENTITY_QUESTIONS,
    payload: data,
});

export const setResponseBasedErrorMessage = data => ({
    type: RIDP_ACTION_TYPES.SET_ERROR_MESSAGE,
    payload: data,
});

export const setUploadedDocuments = data => ({
    type: RIDP_ACTION_TYPES.UPLOAD_DOCUMENT,
    payload: data,
});

export const setFARSResponse = data => ({
    type: RIDP_ACTION_TYPES.VALIDATE_FARS,
    payload: data,
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchCurrentUserInfoDetails = (url, _environment) => async dispatch => {
    const data: IUserInfo = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setRIDPUserInfoData({ ...data }));
    } else {
        console.error('Cannot get current user details', url);
    }
};

export const fetchCurrentUserViewRef = (url, _environment) => async dispatch => {
    const data: IUserViewRef = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setRIDPUserViewRef(data.viewRef));
    } else {
        console.error('Cannot get view ref details', url);
    }
};

export const validateRidpPrimary = (url, payload, responseCode) => async dispatch => {
    const params = [url, payload, undefined, false, undefined, 'application/json'];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);

    if (global.__ENV__.PRODUCTION && data) {
        dispatch(setRidpPrimaryResponse(data));
    } else if (!global.__ENV__.PRODUCTION && data) {
        dispatch(setRidpPrimaryResponse(data[responseCode]));
    } else {
        dispatch(setRidpPrimaryResponse(null));
        console.error('there is an error in submitting contact information');
    }
};

export const validateRidpSecondary = (url, payload) => async dispatch => {
    //const params = [url, payload, undefined, false];
    const params = [url, payload, undefined, false, undefined, 'application/json'];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setRidpSecondaryResponse(data));
    } else {
        dispatch(setRidpSecondaryResponse(null));
        console.error('there is an error in submitting contact information');
    }
};

export const uploadDocuments = (url, payload, environment, viewRef) => async dispatch => {
    const params = [url, payload, undefined, false, undefined, 'multipart/form-data'];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setUploadedDocuments(data));
        dispatch(
            fetchCurrentUserInfoDetails(
                endpoints.RIDP_CURRENT_USER_INFO_ENDPOINT.processReplacements({
                    viewRef,
                    ts: Date.now(),
                }),
                environment,
            ),
        );
    } else {
        console.error('there is an error in submitting document');
    }
};

export const validateFARSData = (url, payload) => async dispatch => {
    const params = [url, payload, undefined, false, undefined, 'application/json'];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);

    if (data) {
        dispatch(setFARSResponse(data));
    } else {
        console.error('there is an error in submitting contact information');
    }
};

export const clearDHSReferenceData =
    (url, viewRef, environment, history, existingParams, setErrorMessage, ridpValidateFARSResponse) => async dispatch => {
        const params = [url, null, undefined, false, undefined, 'application/json'];
        const data = global.__ENV__.PRODUCTION
            ? await API.postData(params, dispatch, actions)
            : await API.getData(url, dispatch, actions, true);

        if (data && data.ResponseCode === ResponseCodes.HS000000) {
            dispatch(
                fetchCurrentUserInfoDetails(
                    endpoints.RIDP_CURRENT_USER_INFO_ENDPOINT.processReplacements({
                        viewRef,
                        ts: Date.now(),
                    }),
                    environment,
                ),
            );
            history.push(`${RIDP_CONTACT_INFO}?${existingParams.toString()}`);
        } else {
            setErrorMessage('ridp.identityquestions.technicalerror');
            dispatch(
                setFARSResponse({
                    ...ridpValidateFARSResponse,
                    ResponseMetadata: {
                        ...ridpValidateFARSResponse.ResponseMetadata,
                        ResponseCode: '',
                    },
                }),
            );
        }
    };
